import * as pdfjs from "pdfjs-dist";
import { confirmMimeWithMagicBytes } from "./fileUtils";
export const validateFile = async (file, options) => {
    const { maxFileSize = 50 * 1024 * 1024, // 50MB
    acceptedFileTypes = [
        "application/pdf",
        "text/csv",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ], } = options;
    if (file.size > maxFileSize) {
        const error = `${file.name} exceeds maximum size of ${(maxFileSize /
            1024 /
            1024).toFixed(1)}MB`;
        return { ok: false, error, errorType: 'FileExceedsMaxSize' };
    }
    if (acceptedFileTypes.length > 0 && !acceptedFileTypes.includes(file.type)) {
        const error = `${file.name} has unsupported file type.`;
        return { ok: false, error, errorType: 'UnsupportedFileType' };
    }
    const { ok: isMatch, actualMagicBytes, expectedMagicBytes, } = await confirmMimeWithMagicBytes(file, file.type);
    if (isMatch) {
        if (file.type === "application/pdf") {
            const arrayBuffer = await file.arrayBuffer();
            try {
                await pdfjs.getDocument({ data: arrayBuffer }).promise;
                return { ok: true, error: "" };
            }
            catch (error) {
                const e = error;
                if (e.name === "PasswordException") {
                    const error = `${file.name} is password-protected. Please upload an unlocked PDF.`;
                    return { ok: false, error, errorType: 'PasswordProtected' };
                }
                else {
                    const error = `${file.name} is corrupted.`;
                    return { ok: false, error, errorType: 'CorruptedFile' };
                }
            }
        }
        return { ok: true, error: "" };
    }
    else {
        const error = `${file.name} does not match its claimed file type.`;
        return {
            ok: false,
            error,
            errorType: 'MagicByteMismatch',
            details: {
                actualMagicBytes,
                expectedMagicBytes,
            },
        };
    }
};
